import { render, staticRenderFns } from "./AddMockTest.vue?vue&type=template&id=10e75aa4&scoped=true"
import script from "./AddMockTest.vue?vue&type=script&lang=js"
export * from "./AddMockTest.vue?vue&type=script&lang=js"
import style0 from "./AddMockTest.vue?vue&type=style&index=0&id=10e75aa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e75aa4",
  null
  
)

export default component.exports